<template>
  <div class="diy-tooltip">
    <div class="diy-tooltip__trigger" aria-describedby="tooltip">
      <slot ref="trigger" name="tooltip-handler">
        <AppIcon icon="fas fa-info-circle" />
      </slot>
    </div>
    <!-- content -->
    <div class="diy-tooltip__template" :class="placement" ref="popperContent">
      <div class="diy-tooltip__template-inner" :class="size" role="tooltip">
        <slot name="tooltip-content" />
        <span v-if="message" class="diy-tooltip__template-message">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { createTippy } from 'Plugins/tippy-js'
// Components
import AppIcon from 'Ui/AppIcon'

export default {
  name: 'AppTooltip',

  components: {
    AppIcon,
  },

  props: {
    active: {
      type: Boolean,
      default: true,
    },

    message: {
      type: String,
      default: '',
    },

    placement: {
      type: String,
      default: 'top',
    },

    trigger: {
      type: String,
      default: 'mouseenter',
    },

    size: {
      type: String,
      default: 'medium',
    },
  },

  data() {
    return {
      tooltipInstance: null,
    }
  },

  methods: {
    checkActiveStatus() {
      this.active ? this.tooltipInstance.enable() : this.tooltipInstance.disable()
    },

    async runSetup() {
      await this.$nextTick()
      const trigger = this.$el.querySelector('.diy-tooltip__trigger').firstElementChild
      const template = this.$refs.popperContent

      this.tooltipInstance = createTippy(trigger, template, {
        trigger: this.trigger,
        placement: this.placement,
      })

      this.checkActiveStatus()
    },
  },

  watch: {
    active(newValue) {
      !newValue && this.checkActiveStatus()
      newValue && this.checkActiveStatus()
    },

    placement(newValue) {
      newValue && this.tooltipInstance.destroy(), this.runSetup()
    },
  },

  created() {
    this.runSetup()
  },
}
</script>

<style scoped>
.diy-tooltip {
  display: inline-block;
  color: var(--c-secondary);
}

.diy-tooltip__template {
  z-index: 3;
}

.diy-tooltip__template.top {
  --tooltip-transform: translateY(4px);
}

.diy-tooltip__template.bottom {
  --tooltip-transform: translateY(-4px);
}

.diy-tooltip__template.left {
  --tooltip-transform: translateX(4px);
}

.diy-tooltip__template.right {
  --tooltip-transform: translateX(-4px);
}

.diy-tooltip__template-inner {
  display: block;
  font-size: 14px;
  font-weight: 600;
  font-size: inherit;
  color: var(--c-primary);
  padding: 6px 10px;
  max-width: 350px;
  border: none;
  border-radius: 4px;
  background-color: #fff;
  /* border: 1px solid rgba(0, 8, 16, 0.15); */
  box-shadow: 0 2px 10px -3px var(--rgba-default);
  z-index: 300;
  pointer-events: none;
}

.diy-tooltip__template-inner .app-icon {
  font-size: 12px;
  color: var(--c-secondary);
}

.diy-tooltip__template-inner.small {
  font-size: 12px;
  line-height: 20px;
}

.diy-tooltip__template-inner.medium {
  font-size: 13px;
  line-height: 20px;
}

.diy-tooltip__template-inner.large {
  font-size: 16px;
  line-height: 20px;
}

.diy-tooltip__template-message {
  display: flex;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  width: max-content;
  max-width: 300px;
}

/* transition */
.tooltip-enter-active,
.tooltip-leave-active {
  transition: all var(--transition--default);
}

.tooltip-enter,
.tooltip-leave-to {
  opacity: 0;
  transform: var(--tooltip-transform);
}
</style>
